import * as React from 'react';
import { useMemo } from 'react';
import { useMount } from '../core/hooks/useMount';


type Props = {
  pathname: string;
  search?: string;
  replace?: boolean;
}


/**
 * ExternalRedirect: a component that redirects to a third-party web address (i.e., one not managed by the app's routing
 * mechanisms)
 */
const ExternalRedirect: React.FC<Props> = ({ pathname, search, replace }) => {
  const route = useMemo(
    () => {
      if (!search) {
        return pathname;
      }

      return `${pathname}${search}`;
    },
    [pathname, search],
  );

  useMount(
    () => {
      if (replace) {
        window.location.replace(route);
      } else {
        window.location.assign(route);
      }
    },
  );

  return null;
};

ExternalRedirect.defaultProps = {
  replace: true,
};

export default ExternalRedirect;
